import * as React from "react"
import { AutocompleteAjaxSeeker } from "@ui-seeker/core"

import { BACKEND_APIS } from "@constants"
import { useAdminBrandForm } from "../../@hooks"
import { formData } from "../../@signals"


export default function AdminBrandsCustomerAutocomplete({ disabled }) {
	const { handleChange } = useAdminBrandForm('customerIDs')
	const value = formData.value?.customerIDs || []

	return <AutocompleteAjaxSeeker
		urlAjax={`${BACKEND_APIS.BRANDS}/crud/customer`}
		label="Customers"
		placeholder="Select Customers..."
		multiple
		value={value}
		required
		disabled={disabled}
		onChange={e => handleChange(e.target.value)}
	/>
}
